var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2676 7.125L12.0022 10.5593C11.1949 11.1921 10.0634 11.1921 9.25616 10.5593L4.9541 7.125",
    stroke: "#111827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88787 1.56445H15.3158C16.6752 1.5797 17.969 2.15438 18.896 3.15466C19.823 4.15493 20.3022 5.49348 20.222 6.85857V13.3864C20.3022 14.7515 19.823 16.0901 18.896 17.0904C17.969 18.0906 16.6752 18.6653 15.3158 18.6806H5.88787C2.96796 18.6806 1 16.3051 1 13.3864V6.85857C1 3.9399 2.96796 1.56445 5.88787 1.56445Z",
    stroke: "#111827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.0514800c44da322a4d8d91ede654af4c.svg";
export { ForwardRef as ReactComponent };